import script from "./PCNotificationAlertERP.vue?vue&type=script&setup=true&lang=js"
export * from "./PCNotificationAlertERP.vue?vue&type=script&setup=true&lang=js"

import "./PCNotificationAlertERP.vue?vue&type=style&index=0&id=5fd9d630&lang=scss"

const __exports__ = script;

export default __exports__